<main class="main-content">
  <!-- Table View -->
  <div *ngIf="isTableView" class="table-container fullscreen">
    <!-- Table Header with Options -->
    <div class="table-header">
      <h3 class="table-title">{{ 'dashboard.table.title' | translate }}</h3>
      <div class="table-options">
        <button class="options-btn" (click)="toggleColumnSelector()" [class.active]="showColumnSelector">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M3 6h18M3 12h18M3 18h18" [attr.stroke]="showColumnSelector ? '#1e40af' : '#666'" stroke-width="2" stroke-linecap="round"/>
          </svg>
          {{ 'dashboard.table.columns' | translate }}
        </button>
      </div>
    </div>

    <!-- Column Selector -->
    <div class="column-selector" [class.visible]="showColumnSelector">
        <div class="selector-header">
          <h4>{{ 'dashboard.table.selectOption' | translate }}</h4>
          <label class="select-all">
            <input type="checkbox" (change)="selectAllColumns()" [checked]="areAllColumnsSelected()">
            {{ 'dashboard.table.selectAll' | translate }}
          </label>
        </div>
      <div class="selector-options">
        <label><input type="checkbox" [(ngModel)]="columnVisibility.source" (change)="onColumnVisibilityChange()"> {{ 'dashboard.table.options.source' | translate }}</label>
        <label><input type="checkbox" [(ngModel)]="columnVisibility.device" (change)="onColumnVisibilityChange()"> {{ 'dashboard.table.options.device' | translate }}</label>
        <label><input type="checkbox" [(ngModel)]="columnVisibility.goal" (change)="onColumnVisibilityChange()"> {{ 'dashboard.table.options.goal' | translate }}</label>
      </div>
    </div>

    <table class="data-table">
      <thead>
        <tr>
          <th *ngIf="columnVisibility.personas">{{ 'dashboard.table.headers.personas' | translate }}</th>
          <th *ngIf="columnVisibility.source">{{ 'dashboard.table.headers.sources' | translate }}</th>
          <th *ngIf="columnVisibility.device">{{ 'dashboard.table.headers.device' | translate }}</th>
          <th *ngIf="columnVisibility.goal">{{ 'dashboard.table.headers.goal' | translate }}</th>
          <th *ngIf="columnVisibility.users">{{ 'dashboard.table.headers.users' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of expandedRows; let i = index" [class.row-group-start]="row.personas !== ''">
          <td *ngIf="columnVisibility.personas" class="audience-cell" [class.audience-label]="row.personas !== ''">{{row.personas}}</td>
          <td *ngIf="columnVisibility.source">{{row.source}}</td>
          <td *ngIf="columnVisibility.device">{{row.device}}</td>
          <td *ngIf="columnVisibility.goal">{{row.goal}}</td>
          <td *ngIf="columnVisibility.users" class="users-cell">
            <div class="progress-container">
              <div class="progress-bar" [style.width.%]="row.userProgress"></div>
              <span class="progress-text">{{row.userCount | number}}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Chart View -->
  <div *ngIf="!isTableView" class="dashboard-grid" [class.loading]="isLoading">
    <div class="left-column" [style.opacity]="isLoading ? '0' : '1'" [style.visibility]="isLoading ? 'hidden' : 'visible'">
    <!-- Left Column - 3 Charts (same height) -->
    <div class="chart-container total-users">
      <div class="chart-header">
        <h3>
          {{ 'dashboard.charts.totalUsers' | translate }}
          <span
            class="info-hint"
            role="img"
            tabindex="0"
            [attr.aria-label]="'dashboard.tooltips.totalUsers' | translate"
            [attr.data-tooltip]="'dashboard.tooltips.totalUsers' | translate">ℹ</span>
        </h3>
        <div class="chart-value">
          <div class="value-container">
            <span class="value">##.###</span>
            <span class="percentage">+#.#%</span>
          </div>
        </div>
      </div>
      <div class="chart-content">
        <canvas id="totalUsersPersonasChart"></canvas>
        <div class="no-data-overlay" *ngIf="!totalUsersHasData && !isLoading">
          <span>{{ 'common.noData' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="chart-container users-category">
      <div class="chart-header">
        <h3>
          {{ 'dashboard.charts.enrichedUsers' | translate }}
          <span
            class="info-hint"
            role="img"
            tabindex="0"
            [attr.aria-label]="'dashboard.tooltips.enrichedUsers' | translate"
            [attr.data-tooltip]="'dashboard.tooltips.enrichedUsers' | translate">ℹ</span>
        </h3>
      </div>
      <div class="chart-content">
        <canvas id="usersCategoryPersonasChart"></canvas>
        <div class="no-data-overlay" *ngIf="!usersCategoryHasData && !isLoading">
          <span>{{ 'common.noData' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="chart-container users-device ">
      <div class="chart-header">
        <h3>
          {{ 'dashboard.charts.usersByMetric' | translate:{ metric: (selectedDeviceMetricLabel | translate) } }}
          <span
            class="info-hint"
            role="img"
            tabindex="0"
            [attr.aria-label]="'dashboard.tooltips.usersByDevice' | translate"
            [attr.data-tooltip]="'dashboard.tooltips.usersByDevice' | translate">ℹ</span>
        </h3>
        <div class="device-selector">
          <select (change)="onDeviceMetricChange($any($event.target).value)" [value]="selectedDeviceMetric">
            <option *ngFor="let metric of availableDeviceMetrics" [value]="metric.id">
              {{ metric.name | translate }}
            </option>
          </select>
        </div>
      </div>
        <div class="chart-content">
            <div class="chart-with-legend">
            <div class="chart-wrapper">
              <canvas id="usersDevicePersonasChart" width="200" height="200"></canvas>
            </div>
            <div class="device-legend" *ngIf="usersDeviceLegend.length">
              <div class="legend-item" *ngFor="let entry of usersDeviceLegend">
                <span class="legend-color" [style.background-color]="entry.color"></span>
                <span class="legend-text" [title]="entry.label">{{ entry.label }}</span>
              </div>
            </div>
          </div>
          <div class="no-data-overlay" *ngIf="!usersDeviceHasData && !isLoading">
            <span>{{ 'common.noData' | translate }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="right-section" [class.loading]="isLoading" [style.opacity]="isLoading ? '0' : '1'" [style.visibility]="isLoading ? 'hidden' : 'visible'">
      <div class="audience-treemap-raw">
        <div class="treemap-grid">
          <div class="audience-box audience-1">
            <span class="audience-label">{{ 'personas.treemap.placeholder' | translate:{ index: 1 } }}</span>
            <span class="audience-value">
              <span class="audience-number">###</span>
              <span class="divider"></span>
              <span class="audience-percentage">##%</span>
            </span>
          </div>
          <div class="audience-box audience-2">
            <span class="audience-label">{{ 'personas.treemap.placeholder' | translate:{ index: 2 } }}</span>
            <span class="audience-value">
              <span class="audience-number">###</span>
              <span class="divider"></span>
              <span class="audience-percentage">##%</span>
            </span>
          </div>
          <div class="audience-box audience-3">
            <span class="audience-label">{{ 'personas.treemap.placeholder' | translate:{ index: 3 } }}</span>
            <span class="audience-value">
              <span class="audience-number">###</span>
              <span class="divider"></span>
              <span class="audience-percentage">##%</span>
            </span>
          </div>
          <div class="audience-box audience-4">
            <span class="audience-label">{{ 'personas.treemap.placeholder' | translate:{ index: 4 } }}</span>
            <span class="audience-value">
              <span class="audience-number">###</span>
              <span class="divider"></span>
              <span class="audience-percentage">##%</span>
            </span>
          </div>
          <div class="audience-box audience-5">
            <span class="audience-label">{{ 'personas.treemap.placeholder' | translate:{ index: 5 } }}</span>
            <span class="audience-value">
              <span class="audience-number">###</span>
              <span class="divider"></span>
              <span class="audience-percentage">##%</span>
            </span>
          </div>
          <div class="audience-box audience-6">
            <span class="audience-label">{{ 'personas.treemap.placeholder' | translate:{ index: 6 } }}</span>
            <span class="audience-value">
              <span class="audience-number">###</span>
              <span class="divider"></span>
              <span class="audience-percentage">##%</span>
            </span>
          </div>
        </div>
        <div class="no-data-overlay" *ngIf="!treemapHasData && !isLoading">
          <span>{{ 'common.noData' | translate }}</span>
        </div>

      </div>

      <!-- Bottom - Large Line Chart -->
      <div class="chart-container users-audience chart-has-tooltip" style="margin-bottom: 0px;">
      <div class="chart-header">
        <h3>
          {{ 'dashboard.charts.personasBreakdown' | translate }}
          <span
            class="info-hint"
            role="img"
            tabindex="0"
            [attr.aria-label]="'dashboard.tooltips.personasBreakdown' | translate"
            [attr.data-tooltip]="'dashboard.tooltips.personasBreakdown' | translate">ℹ</span>
        </h3>
      </div>
      <div class="chart-content">
        <canvas id="audiencePersonasChart"></canvas>
        <div class="no-data-overlay" *ngIf="!audienceTrendHasData && !isLoading">
          <span>{{ 'common.noData' | translate }}</span>
        </div>
      </div>
    </div>
    </div>
  </div>

  <!-- Bottom Icons -->
  <div class="bottom-icons">
    <div class="icon-item" [class.active]="isTableView" (click)="toggleTableView()"
         [title]="(isTableView ? 'common.showChartsView' : 'common.showTableView') | translate">
      <!-- In table view mostra l'icona dei grafici (click per tornare ai grafici) -->
      <svg *ngIf="isTableView" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <line x1="4" y1="20" x2="20" y2="20" stroke="#1e40af" stroke-width="2" stroke-linecap="round"/>
        <line x1="5" y1="20" x2="5" y2="11" stroke="#1e40af" stroke-width="2" stroke-linecap="round"/>
        <line x1="10" y1="20" x2="10" y2="5" stroke="#1e40af" stroke-width="2" stroke-linecap="round"/>
        <line x1="15" y1="20" x2="15" y2="9" stroke="#1e40af" stroke-width="2" stroke-linecap="round"/>
        <line x1="20" y1="20" x2="20" y2="14" stroke="#1e40af" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <!-- In chart view mostra l'icona della tabella -->
      <svg *ngIf="!isTableView" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="#666" stroke-width="2" fill="none"/>
        <line x1="9" y1="9" x2="15" y2="9" stroke="#666" stroke-width="2"/>
        <line x1="9" y1="15" x2="15" y2="15" stroke="#666" stroke-width="2"/>
        <line x1="3" y1="9" x2="21" y2="9" stroke="#666" stroke-width="2"/>
      </svg>
      <span [style.color]="isTableView ? '#1e40af' : '#666'">{{ (isTableView ? 'common.charts' : 'common.table') | translate }}</span>
    </div>

    <div class="icon-item" (click)="exportToPNG()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <polyline points="14,2 14,8 20,8" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <line x1="16" y1="13" x2="8" y2="13" stroke="#666" stroke-width="2" stroke-linecap="round"/>
        <line x1="16" y1="17" x2="8" y2="17" stroke="#666" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <span>{{ 'common.png' | translate }}</span>
    </div>

    <div class="icon-item" (click)="exportToExcel()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <polyline points="14,2 14,8 20,8" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 13h6v4H9z" stroke="#666" stroke-width="1" fill="#666"/>
      </svg>
      <span>{{ 'common.xls' | translate }}</span>
    </div>

  </div>
</main>

<!-- Loading Overlay - Outside main content to avoid layout shifts -->
<div *ngIf="isLoading" class="loading-overlay">
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p>{{ 'common.loading' | translate }}</p>
  </div>
</div>
